export const DIALOG_MAX_WIDTH = 512;
